import { patch, del } from 'api/api';

export const PayoutMethodTypes = {
  STRIPE: 'STRP',
  PAYPAL: 'PAYP',
};

export function updatePayoutMethod(itemId, payload) {
  const url = `/services/payoutmethod/${itemId}/`;
  return patch(url, payload);
}

export function deletePayoutMethod(payoutMethodId) {
  const url = `/services/payoutmethod/${payoutMethodId}/`;
  return del(url);
}
